import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { getLayoutSettingValueSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Logo, { INVISIBLE_PROPS, type LogoProps } from "@client/widgets/Logo/component";
import { logoOptionsSelector } from "../selectors";

import "./style.less";

const makeMapStateToProps = () => {
  const logoSelector = getLayoutSettingValueSelector("logo", "sidePanel");

  return (state: AppState): LogoProps & WithIsVisibleHOCProps => {
    if (!logoSelector(state)) return INVISIBLE_PROPS;

    const options = logoOptionsSelector(state);
    if (!options) return INVISIBLE_PROPS;

    return {
      options,
      isVisible: true,
      preventRedirect: state.isEditMode
    };
  };
};

export default connectCustom(makeMapStateToProps)(Logo);
